import React, { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { Tabs, Tab } from '@material-ui/core';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { isAfter } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import './LottoMarket.scss';
import { RootState } from '../../../configs/store';
import formatOdds  from '../../../utils/formatOdds';
import LottoContext from '../Context/Lotto.context';
import ToolTip from '../../ToolTip/ToolTip';
import Outcome from 'src/components/SportsBetting/EventRow/Outcome/Outcome';

export default function LottoMarket() {
  const { t } = useTranslation();
  const {
    singleNumberEvent,
    singleNumberEvent: { marketType, markets, tournamentMarkets }
  } = useSelector((state: RootState) => state.lotto);
  const { bets } = useSelector((state: RootState) => state.betslip);
  const { selectedOddsType } = useSelector((state: RootState) => state.odds);
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);
  const [firstEventMarkets, setFirstEventMarkets] = useState([]);
  const history = useHistory();

  const {
    selectedEvents
  } = useContext(LottoContext);

  const {
    selectedMarket,
    setSelectedMarket,
    tab,
    setTab,
    selectedNumbers,
    setselectedNumbers,
    selectedNumbersForEachMarket,
    setNumbersForEachMarket,
    selectedSpecialEvents,
    isLoading
  } = useContext(LottoContext);

  const [selectedSpecialBets, setSelectedSpecialBet] = useState(0);

  const handleChange = (e, value) => {
    e.preventDefault();
    setTab(value);
  };

  useEffect(() => {
    if (tournamentMarkets && selectedEvents.length > 0){
      let firstEvent = _.filter(selectedEvents, (event) => {
        return event.selected === true && isAfter(utcToZonedTime(event.scheduled * 1000, selectedTimezone), new Date());
      })[0];

      if (!firstEvent){
        firstEvent = _.filter(selectedEvents, (event) => {
          return isAfter(utcToZonedTime(event.scheduled * 1000, selectedTimezone), new Date());
        })[0];
      }

      const marketsIndex = _.findIndex(tournamentMarkets, { eventCode: firstEvent?.code });
      const newTournamentMarkets = tournamentMarkets[marketsIndex]?.markets || [];

      if (!newTournamentMarkets){
        for (const market of tournamentMarkets){
          if (market.markets){
            const newMarkets: any = market.markets;
            newTournamentMarkets.push(newMarkets);
            break;
          }
        }
      }
      if (!newTournamentMarkets || newTournamentMarkets.length === 0){
        history.push('/lotto');
      } else {
        setFirstEventMarkets(_.map(newTournamentMarkets, (market) => market));
      }
    }
  }, [selectedEvents]);

  const dispatch = useDispatch();
  const specialMarketCount =_.filter(firstEventMarkets, ({ layoutType }) => layoutType === 5).length;

  useEffect(() => {
    if (marketType.length > 1 && !isLoading) {
      const typeId = marketType[0].typeCode;
      if (tab !== typeId) {
        setTab(typeId);
      }
    }
  }, [marketType]);

  useEffect(() => {
    if (selectedMarket && tab !== selectedMarket.typeCode && selectedMarket.typeCode >800 && !isLoading){
      setTab(markets[0].typeCode);
    }

    if (selectedMarket && tab !== selectedMarket.typeCode && tab <= 800  && !isLoading) {
      const marketIndex = _.findIndex(marketType, { typeCode: tab });

      const market = _.filter(markets, { typeCode:tab })[marketType[marketIndex]?.default];
      if (market){
        market['header'] = marketType[marketIndex]?.label;
      }

      if (!_.isEmpty(selectedNumbersForEachMarket)){
        let newNumbers = [];

        if (marketIndex >= 0){
          newNumbers = selectedNumbersForEachMarket[marketType[marketIndex].typeCode];
        }

        const oldNumbers = selectedNumbers;

        setNumbersForEachMarket({ ...selectedNumbersForEachMarket, [selectedMarket.typeCode]: oldNumbers });
        setselectedNumbers(newNumbers ? newNumbers : []);
      }
      setSelectedMarket(market);
    } else if ((marketType.length >= 1) && (firstEventMarkets && firstEventMarkets.length > 1) && !isLoading) {
      const typeCode = selectedMarket && selectedMarket.typeCode ? selectedMarket.typeCode : marketType[0].typeCode;
      let market = _.filter(firstEventMarkets, { typeCode, statusNumber: 1 })[0];

      if (selectedMarket){
        const newMarket = _.find(firstEventMarkets, { predictionCount: selectedMarket.predictionCount, typeCode });
        if (newMarket){
          market = newMarket;
        }
      }
      market['header'] = marketType[0]?.label;

      const numberOfMarkets = {};
      for (const mt of marketType){
        const { typeCode } = mt;

        if (typeCode <= 800){
          numberOfMarkets[typeCode] = [];
        }

      }

      setSelectedMarket(market);
      setNumbersForEachMarket(numberOfMarkets);
    } else if ((marketType.length >= 1) && !isLoading && firstEventMarkets.length === 0) {
      const market = _.filter(markets, { typeCode: marketType[0].typeCode, statusNumber: 1 })[0];
      market['header'] = marketType[0]?.label;

      const numberOfMarkets = {};
      for (const mt of marketType){
        const { typeCode } = mt;

        if (typeCode <= 800){
          numberOfMarkets[typeCode] = [];
        }

      }
      setSelectedMarket(market);
      setNumbersForEachMarket(numberOfMarkets);
    }
  }, [tab, markets, selectedEvents, firstEventMarkets]);

  useEffect(() => {
    if (marketType){
      if (!(markets.some((m) => m.typeCode <= 800))){
        setTab(markets[0]?.typeCode);
      } else if ((markets.some((m) => m.typeCode === 500))){
        setTab(500);
      } else {
        setTab(markets[0]?.typeCode);
      }
    }
  }, [markets, selectedEvents, marketType]);

  useEffect(() => {
    if (selectedSpecialEvents){

      let count = 0;
      const indexOfSelected = _.findIndex(selectedSpecialEvents, { selected:true });
      if (indexOfSelected >= 0){

        const filterBet =_.filter(bets, {
          eventCode: selectedSpecialEvents[indexOfSelected].code,
          typeCode: 800
        });

        count += filterBet.length;

        setSelectedSpecialBet(count);
      }
    }
  }, [bets]);

  useEffect(() => {
    // If we are in the 800 market, and we change to other marketType we want to pop number until we have only one combo.
    if (selectedMarket?.typeCode === 800) {
      let regularNumbers =_.filter(selectedNumbers, { type:'ball' });
      let bonusNumbers = _.filter(selectedNumbers, { type: 'bonus' });
      const allowedNumbers = regularNumbers.length - +selectedMarket.specifiers[0].value;
      const allowedBonus = bonusNumbers.length - +selectedMarket.specifiers[1].value;

      regularNumbers = _.dropRight(regularNumbers, allowedNumbers);
      bonusNumbers = _.dropRight(bonusNumbers, allowedBonus);

      setselectedNumbers([...regularNumbers, ...bonusNumbers]);
    }
  }, [selectedMarket]);

  const checkIfOnBetslip = (marketCode, outcome) => {
    const filteredSelected = _.filter(selectedSpecialEvents, { selected:true });
    let found = false;

    for (const event of filteredSelected){

      const index =_.findIndex(bets, {
        eventCode: event.code,
        marketCode: marketCode.toString(),
        outcome: outcome.name
      });

      if (index > -1){
        found = true;
      }
    }
    return found;
  };

  const handleSelected = (market) => (e) => {
    e.preventDefault();
    const index = _.findIndex(marketType, { typeCode:market.typeCode });
    market['header'] = marketType[index]?.label;
    if (market.layoutType === 6){
      setSelectedMarket(market);
      const filteredMarkets = _.filter(markets, { typeCode: market.typeCode });
      const marketIndex = _.findIndex(filteredMarkets, { specifiers: market.specifiers });

      dispatch.lotto.changeDefaultMarket({ market: index, newDefault: marketIndex });
    }
  };

  const addToBetslip = (market, outcome, outcomeName, outcomeCode) => async (e) => {
    e.preventDefault();
    const filteredSelected = _.filter(selectedSpecialEvents, { selected:true });
    for (const event of filteredSelected) {
      await dispatch.betslip.addBet({
        providerCode: 1,
        odds: outcome,
        marketCode: market.code.toString(),
        marketOutcomeCode: outcomeCode.toString(),
        marketName: market.name,
        tournamentName: singleNumberEvent.name,
        datetime: event.scheduled* 1000,
        sport: 'numbers',
        jsonLabel: outcomeName,
        outcome: outcomeName,
        eventCode: event.code,
        productType: 4,
        type: 'numbers',
        country: singleNumberEvent.country,
        typeCode: 800
      });
    }
  };

  const removeFromBetslip = (marketCode:string, outcome:{name:string, value: number}) => async (event) => {
    event.preventDefault();
    const filteredSelected = _.filter(selectedSpecialEvents, { selected:true });
    const indexOfBets = [];
    for (const events of filteredSelected){
      const index =_.findLastIndex(bets, {
        eventCode: events.code,
        marketCode: marketCode.toString(),
        outcome: outcome.name
      });
      indexOfBets.push(index);
    }
    await dispatch.betslip.removeMultipleBets(indexOfBets);
  };

  return (
    <div className="markets">
      <div className="markets__info">
        <ToolTip
          number={ 2 }
          title={ t('numbers.pickYourMarket') }
          message={ t('numbers.toolTip2') }
          className="markets__number"
        />
      </div>
      <Tabs
        value={ tab }
        variant="scrollable"
        className="market__tabs"
        scrollButtons="off"
        onChange={ handleChange }
        TabIndicatorProps={
          {
            style: {
              display:'none'
            }
          }
        }
      >

        {
          _.map(marketType, (header, index) => {
            return (

              <Tab
                key ={ index }
                label={ header.layoutType !== 5 ? header.label : `${ header.label } +${ specialMarketCount }` }
                value = { header.typeCode }
                className={
                  classNames({
                    'markets__tab':true,
                    'markets__tab--selected': tab === header.typeCode
                  })
                }
                icon={
                  selectedSpecialBets > 0 &&
                  <div className={
                    classNames({
                      'markets__indicator': true,
                      'markets__indicator--non-visible': header?.typeCode <= 800
                    })
                  }
                  >{ selectedSpecialBets }</div>
                }
              />
            );
          })
        }
      </Tabs>
      {
        markets &&  (<div className={
          classNames({
            'markets__wrapper': tab < 801,
            'markets__special-wrapper': tab >= 801
          })
        }
        >
          {
            _.map(firstEventMarkets, (m, index) => {
              if (m.typeCode === tab || (tab >= 801 && m.layoutType === 5)){
                if (m.layoutType === 6){

                  return (
                    <Outcome
                      el="button"
                      isSuspended={ m.statusNumber > 1 }
                      className={
                        classNames({
                          'markets__btn' : true,
                          'markets__btn--selected': selectedMarket?.code === m.code,
                          'markets__btn--suspended': m.statusNumber > 1,
                          'markets__btn--main-bonus': m.typeCode === 800
                        })
                      }
                      key={ index }
                      onClick={ handleSelected(m) }
                      value={ formatOdds(m.outcomes[0].value, selectedOddsType) }
                    >
                      <span className="markets__text">
                        { m.name }
                      </span>
                    </Outcome>
                  );
                } else {

                  return (
                    <div className="markets__special-bets" key={ index }>
                      <div className="markets__special-text">{ m.name }</div>
                      <div className="markets__special-buttons-container">
                        {
                          _.map(m.outcomes, (outcome, index) => {
                            const isOnBetslip =checkIfOnBetslip(m.code, outcome);

                            return (<Outcome
                              el="button"
                              isSuspended={ m.statusNumber > 1 }
                              onClick= {
                                !isOnBetslip  ? addToBetslip(m, m.outcomes[index].value, outcome.name, outcome.code)
                                  : removeFromBetslip(m.code, outcome)
                              }
                              className={
                                classNames({
                                  'markets__special-btn' : true,
                                  'markets__special-btn--selected': isOnBetslip,
                                  'markets__btn--suspended': m.statusNumber > 1
                                })
                              }
                              key={ index }
                              value={ formatOdds(m.outcomes[index].value, selectedOddsType) }

                            >
                              <span className="markets__special-btn-text">
                                { outcome.name }
                              </span>
                            </Outcome>
                            );
                          })
                        }
                      </div>
                    </div>
                  );
                }
              } else return null;
            })
          }
        </div>)
      }
    </div>
  );
}
